import classNames from 'classnames';
import { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styles from './Button.module.scss';

type Variant = 'primary' | 'accent' | 'secondary' | 'outline' | 'danger' | 'ghost';

type ButtonAsButton = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; to?: never; href?: never };
type ButtonAsRouterLink = Omit<LinkProps, 'className'> & { variant?: Variant; className?: string; href?: never };
type ButtonAsAnchor = AnchorHTMLAttributes<HTMLAnchorElement> & { variant?: Variant; to?: never; href: string };

type ButtonProps = ButtonAsButton | ButtonAsRouterLink | ButtonAsAnchor;

export const Button = ({ variant = 'primary', className, ...rest }: ButtonProps) => {
	const classes = classNames(styles.button, styles[variant], className);

	if ('to' in rest && rest.to !== undefined) {
		const { to, ...linkRest } = rest;
		return <Link to={to} className={classes} {...linkRest} />;
	}

	if ('href' in rest && rest.href !== undefined) {
		const { href, ...anchorRest } = rest;
		return <a href={href} className={classes} {...anchorRest} />;
	}

	const { type = 'button', ...buttonRest } = rest as ButtonHTMLAttributes<HTMLButtonElement>;
	return <button {...buttonRest} type={type} className={classes} />;
};
